import ModalContext from 'contexts/ModalContext'
import React, { ComponentProps, useCallback, useContext } from 'react'
import _LoyaltyPointsEarn from './_LoyaltyPointsEarn'
import LoyaltyPointsEarnBreakdownModal from './LoyaltyPointsEarnBreakdownModal'

type InheritedPriceRowLoyaltyPointsProps = Omit<ComponentProps<typeof _LoyaltyPointsEarn>, 'onInfoIconClick'>

interface Props extends InheritedPriceRowLoyaltyPointsProps {
  itemTitle?: string
}

function LoyaltyPointsEarnWithBreakdownModal({ itemTitle, calculationRequests, ...rest }: Props) {
  const showModal = useContext(ModalContext)
  const handleInfoClick = useCallback(() => {
    showModal(<LoyaltyPointsEarnBreakdownModal calculationRequests={calculationRequests} itemTitle={itemTitle} />)
  }, [showModal, calculationRequests, itemTitle])

  return <_LoyaltyPointsEarn {...rest} calculationRequests={calculationRequests} onInfoIconClick={handleInfoClick} />
}

export default LoyaltyPointsEarnWithBreakdownModal
